import styled, { css } from "styled-components";
import AntCheckbox from "antd/es/checkbox";
import { phoneMinWidth } from "common/NewLook/layout.ts";

export const getCheckboxStyles = (bgColor?: string) => css`
  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-inner::after,
  .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover
    .ant-checkbox-checked:not(.ant-checkbox-disabled)
    .ant-checkbox-inner {
    background: ${(p) => bgColor || p.theme.colors.primaryBlue}!important;
    border-color: ${(p) => bgColor || p.theme.colors.primaryBlue}!important;
  }
  .ant-checkbox-inner {
    border-color: ${(p) => p.theme.colors.checkboxBorderColor} !important;
    background: ${(p) => p.theme.colors.cardBgColor};
    &::after {
      border-color: ${(p) => p.theme.colors.buttonText};
    }
  }

  &.ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner,
  .ant-checkbox-checked::after {
    border-color: ${(p) => p.theme.colors.checkboxBorderColor};
    @media (min-width: ${phoneMinWidth}) {
      border-color: ${(p) => bgColor || p.theme.colors.primaryBlue};
    }
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background: ${(p) => p.theme.colors.cardBgColor}!important;
  }
`;

export const disabledStyle = css`
  .ant-checkbox-checked .ant-checkbox-inner {
    background: ${(p) => p.theme.colors.disabledInput} !important;
    border-color: ${(p) => p.theme.colors.checkboxBorderColor} !important;
  }
  .ant-checkbox-inner::after {
    border-color: ${(p) => p.theme.colors.disabledText} !important;
  }
  .ant-checkbox-inner {
    background: ${(p) => p.theme.colors.disabledInput} !important;
    border-color: ${(p) => p.theme.colors.checkboxBorderColor} !important;
  }
  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background: ${(p) => p.theme.colors.disabledText} !important;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: ${(p) => p.theme.colors.checkboxBorderColor} !important;
  }
  .ant-checkbox .ant-checkbox-input {
    cursor: not-allowed;
  }
`;

const Checkbox = styled(AntCheckbox)<{
  $useDisabledStyles?: boolean;
  $isError?: boolean;
  $size?: number;
}>`
  ${(p) =>
    p.$useDisabledStyles &&
    !p.checked &&
    `
  &.ant-checkbox-wrapper, .ant-checkbox-input {
    cursor: not-allowed;
  }
`};
  ${(p) =>
    p.$isError ? getCheckboxStyles(p.theme.colors.red) : getCheckboxStyles()};
  ${(p) =>
    p.$size &&
    `
  .ant-checkbox-inner {
    width: ${p.$size}px;
    height: ${p.$size}px;
    &::after {
      width: ${p.$size * 0.4}px;
      height: ${p.$size * 0.6}px;
    }
  }
  .ant-checkbox-inner, .ant-checkbox-checked::after {
    border-radius: ${p.$size > 20 ? 6 : 2}px;
  }
  .ant-checkbox-checked .ant-checkbox-inner:after {
    border-width: ${p.$size > 20 ? 3 : 2}px;
  }
`};
  ${(p) => p.$useDisabledStyles && disabledStyle}
`;

Checkbox.Group = styled(Checkbox.Group)`
  &.ant-checkbox-group .ant-checkbox .ant-checkbox-inner {
    background: ${(p) => p.theme.colors.cardBgColor};
    border-color: ${(p) => p.theme.colors.checkboxBorderColor} !important;
    &::after {
      border-color: ${(p) => p.theme.colors.buttonText};
    }
  }
  &.ant-checkbox-group .ant-checkbox-checked .ant-checkbox-inner {
    background: ${(p) => p.theme.colors.primaryBlue};
    border-color: ${(p) => p.theme.colors.primaryBlue} !important;
  }
`;

export default Checkbox;
